import { useApiClient } from '../../../hooks/useApiClient';
import { ENaturezaDocumentacao } from '../../../enums/ENaturezaDocumentacao';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const getExistsAndIsPrimeiroAdquirente = async (cpfCnpj: string) => {
    const resposta = await httpCall.get(`/dief-cfem/api/declarante/primeiro-adquirente/${cpfCnpj}`);

    return resposta.data;
  };

  const getIsTitularArrendatario = async (cpfCnpj: string) => {
    const resposta = await httpCall.get(`/dief-cfem/api/declarante/titular-arrendatario/${cpfCnpj}`);

    return resposta.data;
  };

  const getCnpjNaturezaId = async (cpfCnpj: string) => {
    let result;
    await httpCall
      .get(`/dief-cfem/api/declarante/${cpfCnpj}`)
      .then((resposta) => {
        result = resposta.data['naturezaDocumentoIdentificacao'].toString();
      })
      .catch((err) => {
        console.error(err);
        throw err;
      });

    return result;
  };

  return {
    getExistsAndIsPrimeiroAdquirente,
    getIsTitularArrendatario,
    getCnpjNaturezaId,
  };
};
